import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { ManagementReportAccountingExecutionService } from '@core/services/entities/management-report-accounting-execution.service';
import { CreateManagementReportAccountingExecutionRequestDto } from '@domain/management-report-accounting-execution/dtos/create-management-report-accounting-execution.request.dto';
import { DispatchErpManagementReportAccountingExecutionRequestDto } from '@domain/management-report-accounting-execution/dtos/dispatch-erp-management-report-accounting-execution.request.dto';
import { DispatchErpManagementReportAccountingExecutionResponseDto } from '@domain/management-report-accounting-execution/dtos/dispatch-erp-management-report-accounting-execution.response.dto';
import { ManagementReportAccountingExecutionResponseDto } from '@domain/management-report-accounting-execution/dtos/management-report-accounting-execution.response.dto';
import { PreviewManagementReportAccountingExecutionResponseDto } from '@domain/management-report-accounting-execution/dtos/preview-management-report-accounting-execution.response.dto';
import { ManagementReportAccountingExecutionRepository } from '@domain/management-report-accounting-execution/repositories/management-report-accounting-execution.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManagementReportAccountingExecutionRepositoryService
  implements ManagementReportAccountingExecutionRepository
{
  constructor(
    private managementReportAccountingExecutionService: ManagementReportAccountingExecutionService,
  ) {}

  create(
    request: CreateManagementReportAccountingExecutionRequestDto,
  ): Observable<ApiResponse<ManagementReportAccountingExecutionResponseDto>> {
    return this.managementReportAccountingExecutionService.create(request);
  }

  show(
    request: RefId,
  ): Observable<ApiResponse<ManagementReportAccountingExecutionResponseDto>> {
    return this.managementReportAccountingExecutionService.show(request);
  }

  download(request: RefId): Observable<ApiResponse<{ viewUrl: string }>> {
    return this.managementReportAccountingExecutionService.download(request);
  }

  preview(
    request: RefId,
  ): Observable<
    ApiResponse<PreviewManagementReportAccountingExecutionResponseDto>
  > {
    return this.managementReportAccountingExecutionService.preview(request);
  }

  delete(request: RefId): Observable<ApiResponse<void>> {
    return this.managementReportAccountingExecutionService.delete(request);
  }

  dispatchErp(
    request: DispatchErpManagementReportAccountingExecutionRequestDto,
  ): Observable<
    ApiResponse<DispatchErpManagementReportAccountingExecutionResponseDto>
  > {
    return this.managementReportAccountingExecutionService.dispatchErp(request);
  }
}
